export const SYSTEM_VERSION = 'system_version'
export const CALL_TO_ACTION = 'call_to_action'
export const SIMPLE_MESSAGE = 'simple_message'